/**
 * Load the TAP stamp PNG from /public. Cached after first load.
 *
 * The PNG should have a transparent background; opaque pixels become the
 * "protected" region in the final image (no checker transparency applied).
 */

const STAMP_URL = "/tap-stamp.png";

let cached: Promise<ImageBitmap> | null = null;

export function loadTapStamp(): Promise<ImageBitmap> {
  if (cached) return cached;
  cached = (async () => {
    const res = await fetch(STAMP_URL);
    if (!res.ok) {
      throw new Error(`Failed to load stamp: ${res.status} ${res.statusText}`);
    }
    const blob = await res.blob();
    return await createImageBitmap(blob);
  })();
  return cached;
}
